import PropTypes from 'prop-types';
import { useFormContext, Controller } from 'react-hook-form';
import MultiselectInvoiceTaxes from 'Components/Organisms/MultiselectInvoiceTaxes/MultiselectInvoiceTaxes';

export default function RHFMultiselectInvoiceTaxes({ name, onChangeTaxes, ...other }) {
    const { control } = useFormContext();

    return (
        <Controller
            name={name}
            control={control}
            render={({ field, fieldState: { error } }) => (
                <MultiselectInvoiceTaxes
                    {...field}
                    onChange={(newValue) => {
                        const oldValue = field.value;
                        field.onChange(newValue);
                        if (onChangeTaxes) onChangeTaxes(oldValue, newValue);
                    }}
                    error={error?.message}
                    {...other}
                />
            )}
        />
    );
}

RHFMultiselectInvoiceTaxes.propTypes = {
    name: PropTypes.string.isRequired,
    onChangeTaxes: PropTypes.func,
};
